var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Fab, useMediaQuery } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ContentAdd from '@material-ui/icons/Add';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { useTranslate } from 'ra-core';
import Button, { sanitizeButtonRestProps } from './Button';
/**
 * Opens the Create view of a given resource
 *
 * Renders as a regular button on desktop, and a Floating Action Button
 * on mobile.
 *
 * @example // basic usage
 * import { CreateButton } from 'react-admin';
 *
 * const CommentCreateButton = () => (
 *     <CreateButton basePath="/comments" label="Create comment" />
 * );
 */
var CreateButton = function (props) {
    var _a = props.basePath, basePath = _a === void 0 ? '' : _a, className = props.className, classesOverride = props.classes, _b = props.icon, icon = _b === void 0 ? defaultIcon : _b, _c = props.label, label = _c === void 0 ? 'ra.action.create' : _c, _d = props.scrollToTop, scrollToTop = _d === void 0 ? true : _d, variant = props.variant, rest = __rest(props, ["basePath", "className", "classes", "icon", "label", "scrollToTop", "variant"]);
    var classes = useStyles(props);
    var translate = useTranslate();
    var isSmall = useMediaQuery(function (theme) {
        return theme.breakpoints.down('sm');
    });
    var location = useMemo(function () { return ({
        pathname: basePath + "/create",
        state: { _scrollToTop: scrollToTop },
    }); }, [basePath, scrollToTop]);
    return isSmall ? (React.createElement(Fab, __assign({ component: Link, color: "primary", className: classnames(classes.floating, className), to: location, "aria-label": label && translate(label) }, sanitizeButtonRestProps(rest)), icon)) : (React.createElement(Button, __assign({ component: Link, to: location, className: className, label: label, variant: variant }, rest), icon));
};
var defaultIcon = React.createElement(ContentAdd, null);
var useStyles = makeStyles(function (theme) { return ({
    floating: {
        color: theme.palette.getContrastText(theme.palette.primary.main),
        margin: 0,
        top: 'auto',
        right: 20,
        bottom: 60,
        left: 'auto',
        position: 'fixed',
        zIndex: 1000,
    },
}); }, { name: 'RaCreateButton' });
CreateButton.propTypes = {
    basePath: PropTypes.string,
    classes: PropTypes.object,
    className: PropTypes.string,
    icon: PropTypes.element,
    label: PropTypes.string,
};
export default memo(CreateButton, function (prevProps, nextProps) {
    return (prevProps.basePath === nextProps.basePath &&
        prevProps.label === nextProps.label &&
        prevProps.translate === nextProps.translate &&
        prevProps.to === nextProps.to &&
        prevProps.disabled === nextProps.disabled);
});
